import { AuthPermission, AuthScope, CrewMember, PersonaType } from '@bechtel/types';
import * as Rights from '~/components/atoms/rights';
import { AppUser } from './types';

export const superIntendent: CrewMember = {
  id: '1',
  firstName: 'firstName',
  lastName: 'lastName',
  persona: PersonaType.SUPERINTENDENT,
  imageUrl: undefined,
  subGroupDescription: 'SuperIntendent',
  crew: {
    id: '1',
    crewNumber: 'PF-001',
  },
};

export const mockedFM: Partial<AppUser> = {
  id: 'MOCKED_FM_USER_ID_1',
  email: '',
  firstName: '',
  lastName: '',
  roles: [],
  rights: [
    { rightName: Rights.Workpackage },
    { rightName: Rights.AssignNightFM },
    //TODO: for testing ONLY, FM do NOT need explicit rights for claim/resolve, they are assigned based on ownership
    { rightName: Rights.ClaimMilestone },
    // { rightName: Rights.ViewBlock },
  ],
  permissionScopes: [],
  permissions: [],
};

export const mockedGF: Partial<AppUser> = {
  id: 'MOCKED_GF_USER_ID_1',
  email: '',
  firstName: '',
  lastName: '',
  roles: [],
  permissions: [
    // {
    //   id: AuthPermission.MANAGE_PLANNING,
    //   permission: {
    //     id: AuthPermission.MANAGE_PLANNING,
    //     name:
    //   },
    //   scope: {
    //     id: AuthScope.MY_WORK_PACKAGES,
    //   },
    // },
  ],
  permissionScopes: [],
  rights: [
    { rightName: Rights.Workpackage },
    { rightName: Rights.AssignFM },
    //TODO: for testing ONLY, GF do NOT need explicit rights for claim/resolve, they are assigned based on ownership
    { rightName: Rights.ClaimMilestone },
    { rightName: Rights.ResolveBlock },
    { rightName: Rights.CanChangeFM },
    { rightName: Rights.CanPlanMilestones },
    { rightName: Rights.ViewPlan },
  ],
};

export const mockedSUP: Partial<AppUser> = {
  id: 'MOCKED_SUP_USER_ID_1',
  email: '',
  firstName: '',
  lastName: '',
  roles: [],
  permissions: [
    {
      id: AuthPermission.MANAGE_PLANNING,
      permission: {
        permissionId: AuthPermission.MANAGE_PLANNING,
        name: '',
        applicableScopes: [],
        module: { id: '', name: '', permissions: [], moduleTypeId: '', isActive: true },
      },
      scope: {
        id: AuthScope.MY_WORK_PACKAGES,
        name: '',
      },
    },
  ],
  rights: [
    { rightName: Rights.Workpackage },
    { rightName: Rights.AssignFM },
    { rightName: Rights.AssignGF },
    //TODO: for testing ONLY, FM do NOT need explicit rights for claim/resolve, they are assigned based on ownership
    { rightName: Rights.ClaimMilestone },
    { rightName: Rights.ResolveBlock },
    { rightName: Rights.CanChangeGF },
    { rightName: Rights.CanPlanMilestones },
    { rightName: Rights.ViewPlan },
  ],
};

export const mockedFE: Partial<AppUser> = {
  id: 'MOCKED_FE_USER_ID_1',
  email: '',
  firstName: '',
  lastName: '',
  roles: [],
  rights: [
    { rightName: Rights.Workpackage },
    { rightName: Rights.CommodityActivity },
    { rightName: Rights.ApproveMilestone },
    { rightName: Rights.ClaimMilestone },
    { rightName: Rights.ResolveAnyBlock },
    { rightName: Rights.ResolveBlock },
  ],
};

export const mockedRandom: Partial<AppUser> = {
  id: 'MOCKED_RANDOM_USER_ID_1',
  rights: [],
};

export const mockedSuperUser: Partial<AppUser> = {
  id: 'MOCKED_SU_USER_ID_1',
  email: '',
  firstName: '',
  lastName: '',
  roles: [],
  rights: [
    { rightName: Rights.Workpackage },
    { rightName: Rights.CommodityActivity },
    { rightName: Rights.ResolveAnyBlock },
    { rightName: Rights.AssignFM },
    { rightName: Rights.AssignGF },
    { rightName: Rights.AssignSUP },
    { rightName: Rights.CanChangeSuperintendent },
    { rightName: Rights.ViewPlan },
  ],
};

type MaybeUser = AppUser | null;
export const mockedUserPermissionScopes: MaybeUser = {
  id: 'MOCKED_TEST_USER_ID_1',
  email: 'testuser@testuser.com',
  firstName: 'firstName',
  lastName: 'lastName',
  crewMember: superIntendent,
  roles: [],
  permissionScopes: [],
  permissions: [
    {
      id: AuthPermission.CREATE_BLOCK,
      permission: {
        permissionId: AuthPermission.CREATE_BLOCK,
        name: 'Add attachments to Milestone',
        module: {
          id: AuthPermission.CREATE_BLOCK,
          name: '',
          moduleTypeId: '',
          permissions: [],
        },
        applicableScopes: [
          {
            id: AuthPermission.CREATE_BLOCK,
            name: 'Add attachments to Milestone',
          },
        ],
      },
      scope: {
        id: AuthScope.ALL_WORK_PACKAGES,
        name: 'Assigned',
      },
    },
    {
      id: AuthPermission.RESOLVE_BLOCK,
      permission: {
        permissionId: AuthPermission.RESOLVE_BLOCK,
        name: 'Add attachments to Milestone',
        module: {
          id: AuthPermission.RESOLVE_BLOCK,
          name: '',
          moduleTypeId: '',
          permissions: [],
        },
        applicableScopes: [
          {
            id: AuthPermission.RESOLVE_BLOCK,
            name: 'Add attachments to Milestone',
          },
        ],
      },
      scope: {
        id: AuthScope.ALL_WORK_PACKAGES,
        name: 'Assigned',
      },
    },
    {
      id: AuthPermission.VIEW_BLOCKS,
      permission: {
        permissionId: AuthPermission.VIEW_BLOCKS,
        name: 'Add attachments to Milestone',
        module: {
          id: AuthPermission.VIEW_BLOCKS,
          name: '',
          moduleTypeId: '',
          permissions: [],
        },
        applicableScopes: [
          {
            id: AuthPermission.VIEW_BLOCKS,
            name: 'Add attachments to Milestone',
          },
        ],
      },
      scope: {
        id: AuthScope.APPLICATION,
        name: 'Assigned',
      },
    },
  ],
};
